import { IncidenceDetailsField } from 'modules/payroll_bundle/lib/types'
import {
  booleanModifier,
  centsModifier,
  countryModifier,
  countryOfBirthModifier,
  dateModifier,
  denominationModifier,
  displayCotizationGroup,
  genderModifier,
  healthInsurerModifier,
  highestLevelOfEducationModifier,
  highestLevelOfProfessionalTrainingModifier,
  personnelLeasingModifier,
  residenceModifier,
  salaryCurrencyFrequencyModifier,
  spousesDenominationModifier,
  weekdaysModifier,
  workingHoursModifier,
} from 'modules/payroll_bundle/lib/utils'

export const PersonalFields: IncidenceDetailsField[] = [
  {
    field: 'first_name',
    translationKey: 'first_name',
  },
  {
    field: 'last_name',
    translationKey: 'last_name',
  },
  {
    field: 'birth_name',
    translationKey: 'birth_name',
  },
  {
    field: 'email',
    translationKey: 'email',
  },
  {
    field: 'gender',
    translationKey: 'gender',
    valueModifier: genderModifier,
  },
  {
    field: 'datev_employee_code',
    translationKey: 'datev_employee_code',
  },
  { field: 'payroll_a3nom_integration_code', translationKey: 'payroll_a3nom_integration_code' },
  {
    field: 'identifier_type',
    translationKey: 'identifier_type',
  },
  {
    field: 'identifier',
    translationKey: 'identifier',
  },
  {
    field: 'tax_id',
    translationKey: 'tax_id',
  },
  {
    field: 'social_security_number',
    translationKey: 'social_security_number',
  },
  {
    field: 'bank_number',
    translationKey: 'bank_number',
  },
  {
    field: 'nationality',
    translationKey: 'nationality',
    valueModifier: countryModifier,
  },
  {
    field: 'country_of_birth',
    translationKey: 'country_of_birth',
    valueModifier: countryOfBirthModifier,
  },
  {
    field: 'place_of_birth',
    translationKey: 'place_of_birth',
  },
  {
    field: 'birthday_on',
    translationKey: 'birthday_on',
    valueModifier: dateModifier,
  },
  {
    field: 'address',
    translationKey: 'address',
  },
  {
    field: 'city',
    translationKey: 'city',
  },
  {
    field: 'state',
    translationKey: 'state',
  },
  {
    field: 'postal_code',
    translationKey: 'postal_code',
  },
  {
    field: 'country',
    translationKey: 'country',
    valueModifier: countryModifier,
  },
  {
    field: 'is_resident',
    translationKey: 'resident',
    valueModifier: residenceModifier,
  },
  {
    field: 'irpf_cents',
    translationKey: 'irpf',
    valueModifier: centsModifier,
  },
  { field: 'company_identifier', translationKey: 'company_identifier' },
  { field: 'seniority_calculation_date', translationKey: 'seniority_calculation_date' },

  {
    field: 'location_name',
    translationKey: 'workplace',
  },
]

export const AgreementInformationFields: IncidenceDetailsField[] = [
  {
    field: 'starts_on',
    translationKey: 'contract_start_date',
    valueModifier: dateModifier,
  },
  {
    field: 'start_on',
    translationKey: 'start_date',
  },
  {
    field: 'job_title',
    translationKey: 'job_title',
  },
  {
    field: 'job_catalog_level_name',
    translationKey: 'job_level',
  },
  {
    field: 'ends_on',
    translationKey: 'contract_end_date',
    valueModifier: dateModifier,
  },
  {
    field: 'trial_period_ends_on',
    translationKey: 'trial_period_ends_on',
    valueModifier: dateModifier,
  },
  {
    field: 'es_contract_type',
    translationKey: 'contract_type',
  },
  {
    field: 'es_working_day',
    translationKey: 'working_day',
  },
  {
    field: 'fr_contract_type_name',
    translationKey: 'contract_type',
  },
  {
    field: 'fr_work_type_name',
    translationKey: 'work_type',
  },
  {
    field: 'es_job_description',
    translationKey: 'job_description',
  },
  {
    field: 'es_education_level',
    translationKey: 'education_level',
  },
  {
    field: 'es_professional_category_name',
    translationKey: 'professional_category',
  },
  {
    field: 'es_cotization_group',
    translationKey: 'cotization_group',
    valueModifier: displayCotizationGroup,
  },
  {
    field: 'es_has_teleworking_contract',
    translationKey: 'has_teleworking_contract',
    valueModifier: booleanModifier,
  },
  {
    field: 'es_contract_observations',
    translationKey: 'contract_observations',
  },
  {
    field: 'es_contribution_type',
    translationKey: 'contribution_type',
  },
  {
    field: 'es_cno_occupation',
    translationKey: 'cno_occupation',
  },
  {
    field: 'es_regime',
    translationKey: 'regime',
  },
  {
    field: 'es_tariff_group',
    translationKey: 'tariff_group',
  },
  {
    field: 'es_occupation_code',
    translationKey: 'occupation_code',
  },
  {
    field: 'es_a3innuva_job_position',
    translationKey: 'a3innuva_job_position',
  },
  {
    field: 'fr_professional_category_name',
    translationKey: 'fr_professional_category',
  },
  {
    field: 'fr_mutual_name',
    translationKey: 'mutual',
  },
  {
    field: 'working_hours',
    extraField: 'working_hours_frequency',
    translationKey: 'working_hours',
    valueModifier: workingHoursModifier,
  },
  {
    field: 'working_week_days',
    translationKey: 'working_week_days',
    valueModifier: weekdaysModifier,
  },
  {
    field: 'salary_amount',
    extraField: 'salary_frequency',
    translationKey: 'salary_amount',
    valueModifier: salaryCurrencyFrequencyModifier,
  },
  {
    field: 'fr_coefficient',
    translationKey: 'coefficient',
  },
  {
    field: 'de_flat_rate_tax',
    translationKey: 'de_flat_rate_tax',
  },
  {
    field: 'de_activity_type',
    translationKey: 'de_activity_type',
  },
  {
    field: 'de_employment_type',
    translationKey: 'de_employment_type',
  },
  {
    field: 'de_personal_key_group_id',
    translationKey: 'de_personal_key_group_id',
  },
]

export const InsuranceInformationFields: IncidenceDetailsField[] = [
  {
    field: 'tax_class',
    translationKey: 'tax_class',
  },
  {
    field: 'requested_annual_allowance',
    translationKey: 'requested_annual_allowance',
  },
  {
    field: 'factor',
    translationKey: 'factor',
  },
  {
    field: 'annual_tax_allowance',
    translationKey: 'annual_tax_allowance',
  },
  {
    field: 'monthly_tax_allowance',
    translationKey: 'monthly_tax_allowance',
  },
  {
    field: 'child_tax_allowance',
    translationKey: 'child_tax_allowance',
  },
  {
    field: 'denomination',
    translationKey: 'denomination',
    valueModifier: denominationModifier,
  },
  {
    field: 'spouses_denomination',
    translationKey: 'spouses_denomination',
    valueModifier: spousesDenominationModifier,
  },
]

export const TaxesAndDeductionsFields: IncidenceDetailsField[] = [
  {
    field: 'health_insurer_company_number',
    translationKey: 'health_insurer_company_number',
    valueModifier: healthInsurerModifier,
  },
  {
    field: 'health_insurance_id',
    translationKey: 'health_insurance_id',
  },
  {
    field: 'contribution_class_health_insurance',
    translationKey: 'contribution_class_health_insurance',
  },
  {
    field: 'contribution_class_unemployment_insurance',
    translationKey: 'contribution_class_unemployment_insurance',
  },
  {
    field: 'contribution_class_pension_insurance',
    translationKey: 'contribution_class_pension_insurance',
  },
  {
    field: 'contribution_class_nursing_insurance',
    translationKey: 'contribution_class_nursing_insurance',
  },
  {
    field: 'additional_contribution_to_nursing_insurance',
    translationKey: 'additional_contribution_to_nursing_insurance',
  },
]

export const WorkActivityInformationFields: IncidenceDetailsField[] = [
  {
    field: 'personnel_leasing',
    translationKey: 'personnel_leasing',
    valueModifier: personnelLeasingModifier,
  },
  {
    field: 'highest_level_of_professional_training',
    translationKey: 'highest_level_of_professional_training',
    valueModifier: highestLevelOfProfessionalTrainingModifier,
  },
  {
    field: 'highest_level_of_education',
    translationKey: 'highest_level_of_education',
    valueModifier: highestLevelOfEducationModifier,
  },
  {
    field: 'work_permit_expiration_date',
    translationKey: 'work_permit_expiration_date',
  },
  {
    field: 'residency_permit_expiration_date',
    translationKey: 'residency_permit_expiration_date',
  },
  {
    field: 'certificate_of_study_expiration_date',
    translationKey: 'certificate_of_study_expiration_date',
  },
]
